import { deDE } from "@mui/x-date-pickers"

const germanLocaleText =
  deDE.components.MuiLocalizationProvider.defaultProps.localeText

// LocalizationProvider fills every text it isn't given with the English default,
// so English needs no texts of its own.
export const getPickerLocaleText = (locale) =>
  locale === "de" ? germanLocaleText : undefined
